<template>
  <b-modal
    @hide="onHandleCloseModal('otpVerifiedModal')"
    :visible="getModals.otpVerifiedModal"
    :id="getModals.otpVerfiedModalId"
    :ref="getModals.otpVerfiedModalId"
    title="Verify Contact Details"
    class="imp-popup"
    hide-footer
  >
    <div>
      <div class="p-3">
        <div class="col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto">
          <div class="row my-4">
            <div class="col-12 text-center">
              <img src="@/assets/img/icons/check-icon.svg" alt="Success" />

              <!-- RESET PASSOWRD MODAL ICON -->
              <img src="@/assets/img/icons/reset-password.svg" class="d-none" alt="passowrd" />
            </div>
            <div class="col-12 text-center my-4">
              <p>
                Awesome! Your verification is complete and your
                <br />account has been created! Welcome!
              </p>
              <p class="d-none">
                Yay! Your password has been changed.
                <br />Book your favorite movie tickets!
              </p>
            </div>
            <div class="col-12">
              <button class="btn btn-primary w-100" @click="onSubmitOtpVerification">DONE</button>
            </div>
          </div>
        </div>
      </div>
      <div class="rainbow-line">
        <span v-for="(rainbowLine, rlIndex) in 7" :key="rlIndex"></span>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      // Modal
      "getModals",
      // ERROR
    ]),
  },
  methods: {
    ...mapActions(["onHandleCloseModal", "onSubmitOtpVerification"]),
  },
};
</script>


// WEBPACK FOOTER //
// src/components/modals/verification.vue